export const UPLOAD_LIST_IGNORE = Symbol.for('xjlv2.ui.upload.LIST_IGNORE')
export interface RcFile extends File { uid: string }
export interface UploadFile<Response = unknown> {
  uid: string
  name: string
  size?: number
  type?: string
  url?: string
  thumbUrl?: string
  status?: 'uploading' | 'done' | 'error' | 'removed'
  percent?: number
  originFileObj?: RcFile
  response?: Response
  error?: Error
}
export interface UploadRequestOptions<Response = unknown> {
  file: RcFile | Blob
  filename: string
  action: string
  method: string
  data: Record<string, string | number | boolean | Blob>
  headers: Record<string, string>
  withCredentials: boolean
  onSuccess: (response: Response, xhr?: XMLHttpRequest) => void
  onError: (error: Error, response?: Response) => void
  onProgress: (event: { percent: number }) => void
}
export interface UploadRequestHandle { abort: () => void }
export type BeforeUploadResult = boolean | void | Blob | typeof UPLOAD_LIST_IGNORE
export interface UploadProps<Response = unknown> {
  fileList?: UploadFile<Response>[]
  defaultFileList?: UploadFile<Response>[]
  action?: string | ((file: RcFile) => string | Promise<string>)
  name?: string
  method?: string
  headers?: Record<string, string>
  data?: Record<string, string | number | boolean | Blob> | ((file: RcFile) => Record<string, string | number | boolean | Blob> | Promise<Record<string, string | number | boolean | Blob>>)
  withCredentials?: boolean
  accept?: string
  multiple?: boolean
  disabled?: boolean
  listType?: 'text' | 'picture' | 'picture-card'
  maxCount?: number
  drag?: boolean
  showUploadList?: boolean
  beforeUpload?: (file: RcFile, fileList: RcFile[]) => BeforeUploadResult | Promise<BeforeUploadResult>
  customRequest?: (options: UploadRequestOptions<Response>) => UploadRequestHandle | void
  onRemove?: (file: UploadFile<Response>) => boolean | void | Promise<boolean | void>
}
